import React from 'react';
import { Content, PageWithHeader } from '@backstage/core-components';
import {
  CatalogFilterLayout,
  EntityKindPicker,
  EntityListProvider,
  EntitySearchBar,
  EntityTypePicker,
} from '@backstage/plugin-catalog-react';
import { ArchivedPicker } from '../../input/ArchivedPicker';
import {
  DepartmentPicker,
  useDepartmentTitles,
} from '../../input/DepartmentPicker';
import { ServiceProvidersOnlyPicker } from '../../input/ServiceProvidersOnlyPicker';
import { TeamCardGrid } from './TeamCardGrid';

/**
 * The service providers - the teams that provide or contribute services to
 * the platform - a card each.
 *
 * Which teams these are is decided in the CMDB, not here: a team states
 * `service_provider`, and the CMDB provider labels it, see
 * `LABEL_SERVICE_PROVIDER`.
 *
 * @public
 */
export const ServiceProvidersPage = () => {
  const departmentTitles = useDepartmentTitles();

  return (
    <PageWithHeader
      themeId="groups"
      title="Service Providers"
      subtitle="Teams that provide and contribute services to the platform"
      pageTitleOverride="Service Providers"
    >
      <Content>
        <EntityListProvider>
          <CatalogFilterLayout>
            <CatalogFilterLayout.Filters>
              <EntityKindPicker initialFilter="group" hidden />
              <EntityTypePicker initialFilter="team" hidden />
              <ServiceProvidersOnlyPicker hidden />
              <EntitySearchBar />
              {/* Only the departments of the teams on this page. */}
              <DepartmentPicker
                titles={departmentTitles}
                filtersForAvailableValues={[
                  'kind',
                  'type',
                  'serviceProvidersOnly',
                ]}
              />
              <ArchivedPicker />
            </CatalogFilterLayout.Filters>
            <CatalogFilterLayout.Content>
              <TeamCardGrid departmentTitles={departmentTitles} />
            </CatalogFilterLayout.Content>
          </CatalogFilterLayout>
        </EntityListProvider>
      </Content>
    </PageWithHeader>
  );
};
